import React from 'react';

const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Welcome to Caring Haven</h1>
          <h2>Building Supportive Communities for Our Elderly</h2>
          <p>
            Our core mission at Caring Haven is to build a supportive community for our elderly residents.
            We are dedicated to ensuring a warm, safe, and nurturing environment where our clients can
            remain close to their communities, loved ones, and existing support systems.
          </p>
          <div className="hero-buttons">
            <button onClick={scrollToBooking} className="btn-primary">
              Schedule a Visit
            </button>
            <button onClick={() => {
              const element = document.getElementById('about');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }} className="btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="hero-image">
          <img 
            src="https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
            alt="Caring Haven - A comfortable and welcoming care home environment" 
            className="hero-main-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;